<template>
    <div>
        <div class="modal fade" id="downPaymentPrintModal" tabindex="-1" aria-labelledby="downPaymentPrintModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="downPaymentPrintModalLabel" class="font-weight-bold">Print Invoice Uang Muka</h4>
                        <a type="button" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times"></i>
                        </a>
                    </div>

                    <div class="modal-body">
                        <CRow>
                            <div class="col-5">
                                <label class="form-label font-weight-bold required">Nomor Invoice</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </div>
                            <div class="col-7">
                                <CInput id="DownPaymentNumber" v-model="DownPaymentNumber" class="font-weight-bold" />
                                <label id="errorDownPaymentNumber" class="form-error pb-2" style="display: none; color: red;"></label>
                            </div>                                
                        </CRow>
                        <CRow>
                            <div class="col-5">
                                <label class="form-label font-weight-bold required">Nomor DO</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </div>
                            <div class="col-7">
                                <CInput id="DONumber" v-model="DONumber" class="font-weight-bold" />
                                <label id="errorDONumber" class="form-error pb-2" style="display: none; color: red;"></label>
                            </div>                                
                        </CRow>
                        <CRow class="pb-3">
                            <CCol sm="5">
                                <label class="form-label font-weight-bold required">Tanggal</label>
                                <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                            </CCol>
                            <CCol sm="7">
                                <date-picker
                                    v-model="DownPaymentDate"
                                    format="DD MMM YYYY"
                                    type="date"
                                    placeholder="Select date"
                                    value-type="YYYY-MM-DD"
                                    style="width:100%"
                                ></date-picker>
                                <label id="errorDownPaymentDate" class="form-error" style="display: none; color: red;"></label>
                            </CCol>                                    
                        </CRow>
                       
                        <CButton type="button" @click="printClick()" id="printButton" color="success" style="float: right;"> Print </CButton>
                        <label style="float: right;">&nbsp;&nbsp;</label>
                        <CButton type="button" color="secondary" style="float: right;" data-bs-dismiss="modal" aria-label="Close"> Close </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import datePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { response } from '../../../../infrastructure/constant/response';

export default {
    name: 'DownPaymentPrintForm',
    components: {
        'date-picker' : datePicker,
    },
    mounted:  function () {
    },
    data: function () {
        return {
            InvoiceId: '',
            EventId: '',
            DownPaymentNumber: '',
            DownPaymentDate: '',
            DONumber: '',
        }
    },
    methods: {
        async addClick(id, eventId, downPaymentNumber, downPaymentDate){
            this.Error = 0;
            $(".form-error").css("display", "none");

            this.InvoiceId = id;
            this.EventId = eventId;
            this.DownPaymentNumber = downPaymentNumber;
            this.DownPaymentDate = downPaymentDate;
            this.DONumber = '';

            window.$('#downPaymentPrintModal').modal('show');
        },
        errorShow(errorCode, message){
            document.getElementById(errorCode).style.display = 'block';
            document.getElementById(errorCode).innerHTML = message == undefined ? response.fieldRequired : message;
            this.Error++;
        },
        inputValidation(){
            this.Error = 0;
            $(".form-error").css("display", "none");

            //Validation
            if(this.DownPaymentNumber === '' || this.DownPaymentNumber == null){
                this.errorShow('errorDownPaymentNumber');
            }
            if(this.DONumber == '' || this.DONumber == null){
                this.errorShow('errorDONumber');
            }
            if(this.DownPaymentDate == '' || this.DownPaymentDate == null){
                this.errorShow('errorDownPaymentDate');
            }
        },
        printClick(){
            this.inputValidation();

            //Proses
            if(this.Error == 0){
                const routeData = this.$router.resolve({name: 'Invoice Uang Muka Report Html Template', params: { id:this.InvoiceId, eventid:this.EventId, downpaymentnumber:this.DownPaymentNumber, downpaymentdate:this.DownPaymentDate, donumber:this.DONumber }});
                window.open(routeData.href, '_blank');
            }
        }
    }
}
</script>

<style scoped>
.modal-xl-custom {
    max-width: 1500px;
}
</style>